import { render, staticRenderFns } from "./answerAgain_mode.vue?vue&type=template&id=f763cd56&scoped=true"
import script from "./answerAgain_mode.vue?vue&type=script&lang=js"
export * from "./answerAgain_mode.vue?vue&type=script&lang=js"
import style0 from "./answerAgain_mode.vue?vue&type=style&index=0&id=f763cd56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f763cd56",
  null
  
)

export default component.exports